

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  ActiveCartService,
  GlobalMessageService,
  GlobalMessageType,
  TranslationService
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { combineLatest, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CartFormService } from '../cart-form.service';
import {
  iShippingAddressArray,
  iUpdateCartAddressRequest
} from '../cart.model';
import { CartService } from '../cart.service';
@Component({
  selector: 'cart-po-ship-dd',
  templateUrl: './cart-po-ship-dd.component.html',
  styleUrls: ['./cart-po-ship-dd.component.scss'],
})
export class CartPoShipDdComponent implements OnInit, OnDestroy {
  public shippingAddressList: iShippingAddressArray[] | undefined = [];
  public displaySelectedAddress: any = {};
  public orgUnitName: string = '';
  public orderSummaryDetails: any = {};
  public ponumber: string = '';
  public loadingSpinner: boolean = false;
  enabledDates: Date[] | any;
  public updateCartOrder: iUpdateCartAddressRequest | undefined;
  public cartValidationInProgress: boolean = false;
  protected subscription = new Subscription();
  constructor(
    private cartService: CartService,
    private cartFormService: CartFormService,
    private globalMessageService: GlobalMessageService,
    private userAccount: UserAccountFacade,
    protected cd: ChangeDetectorRef,
    public activeCartService: ActiveCartService,
    public translationService: TranslationService
  ) {
    this.enabledDates = [];
    this.updateCartOrder = {
      addressId: '',
      purchaseOrderNumber: '',
      requestedDeliveryDate: '',
    };
  }

  form: FormGroup = this.cartFormService.form;
  millisecondPerDay = 24 * 60 * 60 * 1000;
  disabledDates: any = [];

  ngOnInit(): void {
    this.form.get('ponumber')?.markAsDirty();
    this.translationService
      .translate('formErrors.globalMsg')
      .subscribe((data) => {
        if (data) {
          this.globalMessageService.add(
            data ?? '',
            GlobalMessageType.MSG_TYPE_INFO,
            60000000
          );
          this.cd.detectChanges();
        }
      });
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.getShippingAddress();
    this.updateCartReviewDetails();
    this.getTheEnableDates();
    this.activeCartService.getActive().subscribe((cart: any) => {
      if (cart.requestedDeliveryDate) {
        const dateObj = new Date(
          `${cart.requestedDeliveryDate?.substring(
            0,

            4
          )}/${cart.requestedDeliveryDate?.substring(
            4,

            6
          )}/${cart.requestedDeliveryDate?.substring(6, 8)}`
        );
        this.form.patchValue({ nominatedDays: dateObj });
      } else {
        this.form.patchValue({ nominatedDays: this.enabledDates[0] });
      }
      if (cart.deliveryAddress) {
        this.displaySelectedAddress = cart.deliveryAddress;
        this.form.patchValue({ address: cart.deliveryAddress });
      }
      this.cd.detectChanges();
    });
  }

  dateLiteral: any = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
  };

  selectAddress(event: any): void {
    this.enabledDates = [];
    this.getTheEnableDates();
    this.form.patchValue({
      nominatedDays: this.enabledDates[0],
    });
    this.displaySelectedAddress = event;
    this.cd.detectChanges();
  }

  getTheEnableDates() {
    this.enabledDates = [];
  
    var startDate = new Date();
    startDate.setDate(startDate.getDate() + 5 ); 
  
    var endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 18); 
  
    Array.from(Array(18)).map(() => {
      if (startDate <= endDate) {
        this.enabledDates.push(new Date(startDate)); 
      }
      startDate.setDate(startDate.getDate() + 1);
    });
  
    this.getDisabledDates(this.enabledDates);
  }
  

  
  getDisabledDates(excludeDates: Array<Date> | undefined) {
    var now = new Date();
    var startDate: Date = new Date(now.setFullYear(now.getFullYear() - 1));
    var endDate: Date = new Date(now.setFullYear(now.getFullYear() + 2)); //change as per your need
    this.disabledDates = [];
    do {
      var found = false;
      excludeDates?.map((date) => {
        var excludeDate: Date = date;
        if (this.IsSameDay(excludeDate, startDate)) {
          found = true;
        }
      });
      if (!found) {
        this.disabledDates.push(startDate);
      }
      startDate = new Date(startDate.getTime() + this.millisecondPerDay);
    } while (startDate <= endDate);
  }

  IsSameDay(date1: Date, date2: Date) {
    if (
      date1.getFullYear() == date2.getFullYear() &&
      date1.getMonth() == date2.getMonth() &&
      date1.getDate() == date2.getDate()
    ) {
      return true;
    } else {
      return false;
    }
  }

  disableButtonWhileNavigation() {
    this.cartValidationInProgress = true;
  }

  getShippingAddress() {
    combineLatest([
      this.userAccount.get(),
      this.cartService.getTheListOfShippingAddress(),
    ]).subscribe(([{ orgUnit }, resp]: any) => {
      this.shippingAddressList = resp?.addresses;
      this.orgUnitName = orgUnit?.name;
      let defaultAddress = this.shippingAddressList?.find(
        (address) => address.defaultAddress
      );
      if (defaultAddress) {
        this.displaySelectedAddress = defaultAddress;
        this.form.patchValue({ address: defaultAddress });
      } else {
        this.displaySelectedAddress = this.shippingAddressList?.[0];
        this.form.patchValue({ address: this.shippingAddressList?.[0] });
      }
      this.cd.detectChanges();
      this.getTheEnableDates();
    });
  }

  getCartDetails() {
    this.subscription.add(
      this.cartService
        .updateCartOrder(this.updateCartOrder)
        ?.subscribe((cartResponse) => { })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
  }

  updateCartReviewDetails() {
    this.subscription.add(
      this.form
        .get('ponumber')
        ?.valueChanges.pipe(
          map((value: string) => {
            this.updateCartOrder = {
              purchaseOrderNumber: value,
              addressId: this.updateCartOrder?.addressId,
              requestedDeliveryDate:
                this.updateCartOrder?.requestedDeliveryDate,
            };
            return value;
          }),
          switchMap(() =>
            this.cartService.updateCartOrder(this.updateCartOrder)
          )
        )
        .subscribe((cartResponse) => { })
    );

    this.subscription.add(
      this.form.get('address')?.valueChanges.subscribe(({ id }: any) => {
        this.updateCartOrder = {
          addressId: id,
          purchaseOrderNumber: this.updateCartOrder?.purchaseOrderNumber,
          requestedDeliveryDate: this.updateCartOrder?.requestedDeliveryDate,
        };
        this.getCartDetails();
      })
    );
    this.subscription.add(
      this.form.get('nominatedDays')?.valueChanges.subscribe((value: Date) => {
        this.updateCartOrder = {
          requestedDeliveryDate:
            value.getFullYear().toString() +
            ('0' + (value.getMonth() + 1)).slice(-2).toString() +
            ('0' + value.getDate()).slice(-2).toString(),
          addressId: this.updateCartOrder?.addressId,
          purchaseOrderNumber: this.updateCartOrder?.purchaseOrderNumber,
        };
        this.getCartDetails();
      })
    );
  }
}
